export const EVENT_SUBSCRIPTION = `
  subscription onEvent($orgId: String!) {
    onEvent(orgId: $orgId) {
      batchId
      orgId
      events {
        id
        orgId
        parentOrgId
        type
        entityId
        entityType
        timestamp
        data
        batchId
      }
      batchTimestamp
    }
  }
`;
